import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ApiKey,
  ApiKeySessionsWithAccessToSpaceOutput,
  QueryApiKeySessionsWithAccessToSpaceArgs,
  QueryApiKeySessionsWithAccessToSpaceSuggestionsArgs,
  Role,
  SearchSuggestionsOutput,
  SessionSpaceAccessRoleGrant,
} from "types/generated";

// A session grant carries no space, no propagated flag and no binding: login flattens all of that
// away, so `origin` is the only attribution left.
type SpaceDetailsApiKeySessionGrantNode = Pick<SessionSpaceAccessRoleGrant, "origin"> & {
  role: Pick<Role, "id" | "name" | "isSystem">;
};

type SpaceDetailsApiKeySessionNode = {
  apiKey: Pick<ApiKey, "id" | "name">;
  roles: Array<SpaceDetailsApiKeySessionGrantNode>;
};

type ApiKeySessionsWithAccessToSpaceData = {
  apiKeySessionsWithAccessToSpace: {
    edges: Array<{ cursor: string; node: SpaceDetailsApiKeySessionNode }>;
    pageInfo: ApiKeySessionsWithAccessToSpaceOutput["pageInfo"];
  };
};

export const API_KEY_SESSIONS_WITH_ACCESS_TO_SPACE: TypedDocumentNode<
  ApiKeySessionsWithAccessToSpaceData,
  QueryApiKeySessionsWithAccessToSpaceArgs
> = gql`
  query ApiKeySessionsWithAccessToSpace($space: ID!, $input: SearchInput!) {
    apiKeySessionsWithAccessToSpace(space: $space, input: $input) {
      edges {
        cursor
        node {
          apiKey {
            id
            name
          }
          roles {
            origin
            role {
              id
              name
              isSystem
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type ApiKeySessionsWithAccessToSpaceCountData = {
  apiKeySessionsWithAccessToSpaceSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const API_KEY_SESSIONS_WITH_ACCESS_TO_SPACE_COUNT: TypedDocumentNode<
  ApiKeySessionsWithAccessToSpaceCountData,
  QueryApiKeySessionsWithAccessToSpaceSuggestionsArgs
> = gql`
  query ApiKeySessionsWithAccessToSpaceCount($space: ID!, $input: SearchSuggestionsInput!) {
    apiKeySessionsWithAccessToSpaceSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
